function resolveDefaultBaseUrl() {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "http://localhost:5174";
}

const viteEnv = typeof import.meta !== "undefined" ? import.meta.env : undefined;
const processEnv =
  typeof globalThis !== "undefined" && globalThis.process?.env
    ? globalThis.process.env
    : undefined;
const rawBaseUrl =
  (viteEnv && viteEnv.VITE_API_BASE_URL) ||
  (processEnv && processEnv.VITE_API_BASE_URL) ||
  resolveDefaultBaseUrl();
const API_BASE_URL = rawBaseUrl.replace(/\/$/, "");

function buildApiUrl(path = "") {
  if (!path) return API_BASE_URL;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

async function apiRequest(path, options = {}) {
  const url = buildApiUrl(path);
  const config = {
    method: options.method || "GET",
    credentials: "include",
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      ...options.headers,
    },
  };

  if (options.body !== undefined) {
    config.body =
      typeof options.body === "string"
        ? options.body
        : JSON.stringify(options.body);
  }

  let response;
  try {
    response = await fetch(url, config);
  } catch (err) {
    const error = new Error(
      "Tidak dapat terhubung ke backend. Pastikan backend aktif dan URL API benar."
    );
    error.code = "NETWORK_ERROR";
    error.cause = err;
    throw error;
  }
  const text = await response.text();
  let payload = text;

  try {
    payload = text ? JSON.parse(text) : null;
  } catch {
    // keep plain text on parse errors
  }

  if (!response.ok) {
    const message =
      payload?.message ||
      payload ||
      `Request failed with status ${response.status}`;
    const error = new Error(message);
    error.status = response.status;
    error.payload = payload;
    throw error;
  }

  return payload;
}

export { apiRequest, API_BASE_URL, buildApiUrl };
